module.exports = __webpack_public_path__ + "static/media/more.bab21aac.svg";